$( document ).ready(function() {
  
  $('.single-slider .slide-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>'
  });

    $('.categories-sliders .categories-slider-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
     prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
    responsive: [
   {
      breakpoint: 1099,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
});

  $('.product-sliders .product-slider-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
     prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
    responsive: [
   {
      breakpoint: 1360,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 801,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
});

$('.customer-slider .customer-list').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',  
    responsive: [
    {
      breakpoint: 801,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(document).ready(function(){
    const $container = $('.product_main_images');
    const $active = $container.find('.slider_box.selected_media_id');
    const startIndex = $container.find('.slider_box').index($active);

    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      initialSlide: startIndex,
      asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: true
    });
  });
  
});




document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".plus-btn").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        const container = btn.closest(".quantity");
        const inventory = parseInt(container.getAttribute("inventory-qtn"));
        const input = container.querySelector(".qty-input");
        const currentQty = parseInt(input.value);

        if (currentQty + 1 > inventory) {
          e.preventDefault();
          alert("Cannot update quantity. Only " + inventory + " items in stock.");
        }
      });
    });
   document.querySelectorAll(".qty-input").forEach(function (input) {
      input.addEventListener("change", checkInventory);
      input.addEventListener("keyup", function (e) {
        if (e.key === "Enter") checkInventory.call(input);
      });

      function checkInventory() {
        const container = this.closest(".quantity");
        const inventory = parseInt(container.getAttribute("inventory-qtn"));
        const enteredQty = parseInt(this.value);

        if (enteredQty > inventory) {
          alert("Cannot update quantity. Only " + inventory + " items in stock.");
          this.value = inventory; 
        }
      }
    });
  });
 document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".quantity-wrapper").forEach(function (wrapper) {
      const input = wrapper.querySelector('input[name="quantity"]');
      const upBtn = wrapper.querySelector('[data-quantity="up"]');
      const downBtn = wrapper.querySelector('[data-quantity="down"]');
      const inv = parseInt(wrapper.getAttribute("inventory-qtn"), 10);

      if (!input || isNaN(inv)) {
        console.warn("Missing input or inventory in:", wrapper);
        return;
      }

     upBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); 
    
      let v = parseInt(input.value, 10) || 0;
      if (v + 1 > inv) {
        alert("Cannot add quantity. Only " + inv + " items in stock.");
      } else {
        input.value = v + 1;
      }
    });

      downBtn.addEventListener("click", function (e) {
        e.preventDefault();
        let v = parseInt(input.value,10) || 0;
        if (v > 1) input.value = v - 1;
      });

      input.addEventListener("change", checkInv);
      input.addEventListener("keyup", function(e) {
        if (e.key === "Enter") checkInv();
      });

      function checkInv() {
        let v = parseInt(input.value,10) || 0;
        if (v > inv) {
          alert("Cannot add quantity. Only " + inv + " items in stock.");
          input.value = inv;
        } else if (v < 1) {
          input.value = 1;
        }
      }
    });
  });




// collection page variant change evenr



const variantInputs = document.querySelectorAll(".js-custom-variant-input");

variantInputs.forEach((variantInput) => {
  variantInput.addEventListener("click", (event) => {
    const clickedInput = event.currentTarget;
    const variantImage = clickedInput.getAttribute("data-image");
    const variantAvailability = clickedInput.getAttribute("data-available");
  
    const productBlock = clickedInput.closest(".product-block__inner");
    const featureImg = productBlock?.querySelector(".js-feature-img");

      if (variantImage && featureImg) {
    
      featureImg.srcset = variantImage;
      featureImg.dataset.srcset = variantImage;

    
      featureImg.src = variantImage.split(" ")[0];
      
    
      if (!featureImg.classList.contains("lazyloaded")) {
        featureImg.classList.add("lazyloaded");
      }
      
    
      if (typeof lazySizes !== "undefined") {
        lazySizes.loader.unveil(featureImg);
      }
      if(variantAvailability == 'false'){
        productBlock.querySelector(".js-add-to-cart").querySelector(".js-btn-txt").innerText = 'Out of stock';
        productBlock.querySelector(".js-add-to-cart").setAttribute("disabled", "disabled");
      }else{
         productBlock.querySelector(".js-add-to-cart").querySelector(".js-btn-txt").innerText = 'Add to Cart';
        productBlock.querySelector(".js-add-to-cart").removeAttribute("disabled");
      }
    } else {
      console.warn("Missing variant image or feature image element");
    }

  });
});

document.querySelectorAll('.js-custom-variant-input').forEach(input => {
  input.addEventListener('change', function () {
    const productWrapper = this.closest('.product-block__inner');
    const priceBox = productWrapper.querySelector('.price');
    const price = this.dataset.price;
    const compare = this.dataset.compareAtPrice;
    const packLabel = this.dataset.label;

    const parentMain = $(this).closest('.variant_input_main');
    parentMain.find('.variant_inputs').removeClass('active');  
    $(this).closest('.variant_inputs').addClass('active');

    const updatePackLabel = $(this).closest('.variant_input_main').prevAll('a.caption').first();
    updatePackLabel.find('.lbl_selected_pack').text(packLabel);

    let priceHTML = '';
    if (compare) {
      // On sale
      priceHTML += `
        <span class="theme-money">${price}</span>
        <span class="was-price theme-money">${compare}</span>
      `;
    } else {
      // Regular price
      priceHTML += `<span class="theme-money">${price}</span>`;
    }
    priceBox.innerHTML = priceHTML;
  });
});

const addToCartBtns = document.querySelectorAll(".js-add-to-cart");
addToCartBtns.forEach((addToCartBtn) => {
  addToCartBtn.addEventListener("click", (event) => {
  event.preventDefault();


  const form = event.target.closest("form");

  if (!form) {
    console.warn("Form not found around the Add to Cart button.");
    return;
  }

  const selectedVariant = form.closest(".product-block__inner").querySelector(".js-custom-variant-input:checked");
  if (selectedVariant) {
    const variantValue = selectedVariant.value;

    console.log("Selected variant value:", variantValue);

  
    const hiddenVariantInput = form.querySelector("input[name='id']");
    if (hiddenVariantInput) {
      hiddenVariantInput.value = variantValue;
    }

    form.submit();
  
  } else {
    alert("Please select a variant before adding to cart.");
  }
});
})


